(function () {
  "use strict";

  angular
    .module("app")
    .controller("loginDirectEditPwdController", loginDirectEditPwdController);

  function loginDirectEditPwdController(
    sysCode,
    loginService,
    $location,
    e2eService,
    $rootScope,
    $routeParams,
    commonService,
    iAmNotRobot,
    $http,
    apiUrl,
    $scope
  ) {
    var vm = this;
    vm.submit = submit;
    vm.autoFill = autoFill;
    vm.sendVerifyCodeFromSignUp = sendVerifyCodeFromSignUp;
    vm.checkVerify = checkVerify;
    vm.iAmNotRobot = iAmNotRobot;
    vm.isShowConfirmUpdate = false;

    vm.view = {
      type: "editPwd",
    };

    // virtual keyboard start
    vm.showVirKey = showVirKey;
    vm.isShowVirKey = false;
    vm.textChanged = textChanged;
    vm.focusObj = null;
    vm.virData = null;
    vm.canSend = false;
    // 針對哪個 input 使用動態鍵盤輸入
    vm.getFocusNewPwd = function () {
      vm.focusObj = "newPwd";
      vm.virData = vm.data.newPwd;
    };
    vm.getFocusConfirmPwd = function () {
      vm.focusObj = "confirmPwd";
      vm.virData = vm.data.confirmPwd;
    };
    vm.checkPassword = function () {
      if (
        vm.data.confirmPwd !== undefined &&
        vm.data.newPwd !== undefined &&
        vm.data.confirmPwd.length >= 6 &&
        vm.data.newPwd.length >= 6
      ) {
        if (vm.data.confirmPwd === vm.data.newPwd) {
          vm.canSend = true;
        }else{
            vm.canSend = false;
        }
      }else{
        vm.canSend = false;
      }
    };

    function textChanged(newPwd) {
      var e = document.getElementById(vm.focusObj);
      e.value = newPwd;
      var $e = angular.element(e);
      $e.triggerHandler("input");
    }

    function showVirKey() {
      if (vm.isShowVirKey) vm.isShowVirKey = false;
      else vm.isShowVirKey = true;
    }

    onInit();

    function onInit() {
      // debugger;
      commonService
        .fetchDecyrptForDirectModifyDto({
          phoneNumber: $routeParams.mobilTel,
          userAccount: $routeParams.userAccount,
          verifyCode: $routeParams.verifyCode,
        })
        .then((data) => {
          vm.data = {
            userAccount: data.data.userAccount,
            verifyCode: data.data.verifyCode,
            sysCode: sysCode,
          };

          vm.form2 = {
            mobilTel: data.data.phoneNumber,
            email: data.data.userAccount,
          };

          vm.form1 = {
            sysCode: sysCode,
            userAccount: data.data.userAccount,
            tel: data.data.phoneNumber,
            validCode: data.data.validCode,
            issend: false,
          };
        });
    }

    function submit() {
      vm.confirmPwd = vm.data.newPwd !== vm.data.confirmPwd;
      if (!vm.confirmPwd) {
        loginService.directModifyUserPassword(vm.data).then(function (data) {
          if (data) {
            toastr.success($rootScope.translate.commonEditPwdSuccess);
            if ($routeParams.mobilTel) {
              vm.view.type = "phone";
              $("#divPhone").show();
            } else {
              $location.path("/login");
            }
          }
        });
      }
    }

    function autoFill() {
      e2eService.directEditPwd(vm.data);
    }

    function sendVerifyCodeFromSignUp() {
      //20180314 Anthony
      //1. Verify reCaptcha with MHRAPI and Google API
      //2-1. Succcess : Go Back to Login step
      //2-2. Fail : throw Error Messege

      //test error situation
      //recaptcha.response = recaptcha.response+'ee';
      if ($("#inputVerify").val().length == 4) {
        vm.form1.issend = true;
        loginService.produceVerifyCodeFromSignUp(vm.form1).then(() => {
          toastr.success($rootScope.translate.commonAlreadySendSMS);
        });
      } else {
        toastr.warning($rootScope.translate.commonReCaptchaFail);
        return false;
      }
    }

    function checkVerify() {
      var param = {
        verifyCode: vm.form1.validCode,
        userAccount: vm.form1.userAccount,
        PhoneNumber: vm.form1.tel,
      };
      loginService.verifyCodeCheckFromSignUp(param).then(function () {
        removeSsoInfo();
        toastr.success($rootScope.translate.alreadyVerifyPhoneNumber);
        $location.path("/login");
      });
    }
  }
})();
